export default __webpack_public_path__ + "static/media/comingsoon.9ecdfef0.png";